import { createCsvValidator } from '~/components/general/createCsvValidator';

export const groupsCsvValidator = createCsvValidator({
    maxFileSizeBytes: 100 * 1024 ** 2,
    requiredHeadings: ['group_id'],
    optionalHeadings: [
        'group_name',
        'org_unit_id',
        'group_time_zone',
        'group_address',
        'group_address_line_2',
        'group_city',
        'group_state',
        'group_zip',
        'group_country',
    ],
});

export const validateGroupsCsv = groupsCsvValidator.validate;
